import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

interface ButtonProps {
  confirmTitle: string;
  cancleTitle: string;
  onClick?: () => void;
  fiexd?: boolean;
  confirmColor?: string;
  confirmBgColor?: string;
  cancleColor?: string;
  cancleBgColor?: string;
  padding?: string;
  confirmType?: 'button' | 'submit' | 'reset';
}

export const TwoButton = ({
  confirmTitle,
  cancleTitle,
  onClick,
  fiexd = false,
  confirmColor = '#FFFFFF',
  confirmBgColor = '#437BE6',
  cancleColor = '#999999',
  cancleBgColor = '#F2F4F6',
  padding = '1.7rem',
  confirmType = 'button',
}: ButtonProps) => {
  const history = useHistory();
  const confirmBtnColor = {
    backgroundColor: confirmBgColor,
    color: confirmColor,
  };
  const cancleBtnColor = {
    backgroundColor: cancleBgColor,
    color: cancleColor,
  };
  const cancleHanler = () => {
    history.goBack();
  };

  return (
    <BtnBox fixed={fiexd} padding={padding}>
      <button type="button" onClick={cancleHanler} style={cancleBtnColor}>
        {cancleTitle}
      </button>
      <button onClick={onClick} style={confirmBtnColor} type={confirmType}>
        {confirmTitle}
      </button>
    </BtnBox>
  );
};

//styled
export const BtnBox = styled.div<{ fixed: boolean; padding: string }>`
  position: ${({ fixed }) => (fixed ? 'fixed' : 'static')};
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  padding: ${({ fixed }) => (fixed ? '2rem 2rem 3.2rem' : '1.2rem 0 0.8rem')};
  background-color: ${(props) => props.theme.textWhiteColor};
  button {
    width: 100%;
    background-color: ${(props) => props.theme.btnBlueColor};
    color: ${(props) => props.theme.textWhiteColor};
    padding: ${(props) => props.padding};
    border-radius: 1.2rem;
    border: 0;
    outline: none;
    font-size: 1.8rem;
    font-weight: 600;
  }
`;
